var map = {
	"./de.json": 818880,
	"./en.json": 508888,
	"./es.json": 491443,
	"./fr.json": 360606,
	"./it.json": 401534,
	"./ja.json": 656990,
	"./ko.json": 84432,
	"./pl.json": 603485,
	"./pt.json": 297912,
	"./ru.json": 628976,
	"./uk.json": 416207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 753579;